module.exports = __webpack_public_path__ + "img/16.558d2279.jpg";